import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  sendCustomerEmail,
  type SendCustomerEmailDto,
  type SentEmailResult,
} from "../api/crm";

/**
 * Phase 3 — posts the outbound email via the admin endpoint and invalidates
 * the 360 snapshot + timeline so the new `email_outbound` event appears
 * without a page refresh. AI Summary + RAG refresh happen server-side as a
 * side effect of the emit; the UI sees it on the next poll/read.
 */
export function useSendEmail(customerId: string) {
  const qc = useQueryClient();
  return useMutation<SentEmailResult, Error, SendCustomerEmailDto>({
    mutationFn: (dto) => sendCustomerEmail(customerId, dto),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["crm", "customer360", customerId] });
      qc.invalidateQueries({ queryKey: ["crm", "timeline", customerId] });
    },
  });
}
